import { render } from "./Green.vue?vue&type=template&id=7a547a5a&scoped=true"
import script from "./Green.vue?vue&type=script&lang=js"
export * from "./Green.vue?vue&type=script&lang=js"

import "./Green.vue?vue&type=style&index=0&id=7a547a5a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a547a5a"]])

export default __exports__